import { Model } from "pinia-orm";

export default class Agency extends Model {
  static entity = "agencies";
  static name = "agency";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.string(""),
      manager: this.string(""),
      managerCode: this.string(""),
      isActive: this.boolean(false),
      telephoneNumber: this.string(""),
      city: this.string(""),
      postalCode: this.string(""),
      address: this.string(""),
      country: this.string(""),
      email: this.string(""),
      agencyGroup: this.attr(null),
    };
  }
}
